import {
  BaseIntegrationConfig,
  BaseIntegrationConfigRequest,
  CloudFormationSetupInfo,
  createIntegrationAPI,
} from "restAPI/GenericIntegrationAPI";
import { CellRenderers } from "utils/tableUtils";

export const ZSCALER_INTEGRATION_TYPE = "ZSCALER_S3";

export interface ZscalerS3Config extends BaseIntegrationConfig {
  authType: string;
  authConfig: {
    roleArn: string;
    externalId: string;
  };
  configProperties: {
    bucketName: string;
    bucketRegion: string;
    prefix?: string;
  };
}

export interface ZscalerS3ConfigRequest extends BaseIntegrationConfigRequest {
  uuid: string;
  status: string;
  authType: string;
  authConfig: {
    roleArn: string;
    externalId: string;
  };
  configProperties: {
    bucketName: string;
    bucketRegion: string;
    prefix?: string;
  };
}

export type ZscalerCloudFormationSetupInfo = CloudFormationSetupInfo;

export const ZscalerS3API = createIntegrationAPI<
  ZscalerS3Config,
  ZscalerS3ConfigRequest
>(ZSCALER_INTEGRATION_TYPE);

export const ZSCALER_ZPA_INTEGRATION_TYPE = "ZSCALER_ZPA_S3";

export const ZscalerZpaS3API = createIntegrationAPI<
  ZscalerS3Config,
  ZscalerS3ConfigRequest
>(ZSCALER_ZPA_INTEGRATION_TYPE);

export const zscalerColumns = [
  {
    title: "S3 Bucket",
    dataIndex: ["configProperties", "bucketName"],
    render: (v: string) => CellRenderers.VALUE_OR_NA(v),
  },
  {
    title: "Prefix",
    dataIndex: ["configProperties", "prefix"],
    render: (v: string) => CellRenderers.VALUE_OR_NA(v),
  },
  {
    title: "Region",
    dataIndex: ["configProperties", "bucketRegion"],
    render: (v: string) => CellRenderers.VALUE_OR_NA(v),
  },
];

export const AWS_REGIONS = [
  { label: "US East (N. Virginia) - us-east-1", value: "us-east-1" },
  { label: "US East (Ohio) - us-east-2", value: "us-east-2" },
  { label: "US West (N. California) - us-west-1", value: "us-west-1" },
  { label: "US West (Oregon) - us-west-2", value: "us-west-2" },
  { label: "Asia Pacific (Mumbai) - ap-south-1", value: "ap-south-1" },
  {
    label: "Asia Pacific (Singapore) - ap-southeast-1",
    value: "ap-southeast-1",
  },
  { label: "Asia Pacific (Sydney) - ap-southeast-2", value: "ap-southeast-2" },
  { label: "Asia Pacific (Tokyo) - ap-northeast-1", value: "ap-northeast-1" },
  { label: "Europe (Frankfurt) - eu-central-1", value: "eu-central-1" },
  { label: "Europe (Ireland) - eu-west-1", value: "eu-west-1" },
  { label: "Europe (London) - eu-west-2", value: "eu-west-2" },
  { label: "Europe (Paris) - eu-west-3", value: "eu-west-3" },
  { label: "South America (São Paulo) - sa-east-1", value: "sa-east-1" },
];

export const arnValidator = {
  pattern: /^arn:aws:iam::\d{12}:role\/[\w+=,.@-]+$/,
  message:
    "Please enter a valid IAM Role ARN (e.g., arn:aws:iam::123456789012:role/RoleName)",
};

export const bucketNameValidator = {
  pattern: /^[a-z0-9][a-z0-9.-]{1,61}[a-z0-9]$/,
  message: "Please enter a valid S3 bucket name",
};
